import { render, staticRenderFns } from "./PenaltiesModal.vue?vue&type=template&id=c23f466e&scoped=true&"
import script from "./PenaltiesModal.vue?vue&type=script&lang=js&"
export * from "./PenaltiesModal.vue?vue&type=script&lang=js&"
import style0 from "./PenaltiesModal.vue?vue&type=style&index=0&id=c23f466e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23f466e",
  null
  
)

export default component.exports